var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-avatar',{staticClass:"rounded-0",attrs:{"width":"40","height":"40"}},[_c('img',{attrs:{"src":require("@/assets/ts3_manager_logo.svg")}})]),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("PLD TS3 Paneli")]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.version))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }